import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { Workspace } from '@workspaces/models/workspaces';
import { WorkspaceStatusClassPipe } from '@workspaces/utils/pipes/workspace-status-class.pipe';
import { WorkspaceStatusPipe } from '@workspaces/utils/pipes/workspace-status.pipe';

@Component({
  selector: 'app-workspace-list-element',
  templateUrl: './workspace-list-element.component.html',
  styleUrls: ['./workspace-list-element.component.scss', '../../../global-workspace-styles.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatChipsModule,
    WorkspaceStatusPipe,
    MatButtonModule,
    WorkspaceStatusClassPipe,
    MatTooltipModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspaceListElementComponent {
  @Input({ required: true }) element!: Workspace;

  @Input() disabled = true;
}
